<template>
  <div class="clearfix" v-if="!pageLoad">
    <div class="spinner-grow text-danger" style="width: 3rem; height: 3rem;margin-top:25vh; margin-left:42%; margin-bottom:5vh" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div v-if="pageLoad" class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 gap-10">
      <div class="position-relative" style="min-width: 220px; max-width: 300px; flex: 1 1 auto;">
        <input
          v-model="searchQuery"
          type="text"
          class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
          :placeholder="$t('business.search')"
        />
      </div>
      <div class="d-flex align-items-center">
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#companyModal"
          style="background-color: #EB9355;"
          @click="initField"
          v-if="current_permissions('create_business', 'edit_business')"
        >
          {{ $t('business.addBusiness') }}
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </button>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('business.code') }}
              </th>
              <th v-if="current_permissions('SUPERADMIN')" scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('business.organization') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('business.name') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('business.description') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('business.maxAmount') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('business.validation') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('business.collectBalance') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('business.transferBalance') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(businessItem) in paginatedBusiness" :key="businessItem.code">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ businessItem.code }}
              </td>
              <td v-if="current_permissions('SUPERADMIN')" class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ businessItem.organization?.name }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ businessItem.name }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ businessItem.description }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ businessItem.maxPayoutAmount }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ (businessItem.validatePayoutBeforProcess==false) ? $t('business.no') : $t('business.yes') }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ businessItem.payinBalance || 0 }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ businessItem.payoutBalance || 0 }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <div class="dropdown">
                  <button class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="flaticon-dots"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a class="dropdown-item d-flex align-items-center" style="color: red;" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#filterLeadModal" @click="showScreen(businessItem.code)" v-if="current_permissions('delete_business')">
                        <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                        <span class="">{{ $t('business.delete') }}</span>
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#companyModal" @click="showBusiness(businessItem.code)" v-if="current_permissions('edit_business')">
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                        <span class="">{{ $t('business.edit') }}</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="filteredTotal>0" class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center">
        <p v-if="filteredTotal>pageSize" class="mb-0 text-paragraph">
          {{ $t('business.showing') }} <span class="fw-bold">{{ showingFrom }}-{{ showingTo }}</span> {{ $t('business.outOf') }}
          <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('business.results') }}
        </p>
        <p v-if="filteredTotal<=pageSize" class="mb-0 text-paragraph">
          {{ $t('business.showing') }} <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('business.outOf') }}
          <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('business.results') }}
        </p>
        <nav class="mt-15 mt-md-0">
          <ul class="pagination mb-0">
            <li v-if="(page-1)>0" class="page-item">
              <a class="page-link" @click="goToPage(page-1)" aria-label="Previous">
                <i class="flaticon-chevron-1"></i>
              </a>
            </li>
            <li v-for="(numPage) in numPages" :key="numPage" class="page-item">
              <a v-if="numPage==page" class="page-link active" href="#">{{ numPage}}</a>
              <a v-else class="page-link" @click="goToPage(numPage)">{{ numPage}}</a>
            </li>
            <li v-if="(page+1)<=numPages" class="page-item">
              <a class="page-link" @click="goToPage(page+1)" aria-label="Next">
                <i class="flaticon-chevron"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

  <!-- Modal Delete Confirmation -->
  <div class="modal fade" id="filterLeadModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-sm modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">{{ $t('business.alert') }}</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="cancel()"></button>
        </div>
        <div class="modal-body">
          <div style="">
            <h6 v-if="errors==''" class="text-red fw-bold mb-0 text-center" style="color: red;">{{ $t('business.confirmDelete') }}</h6>
          </div>
          <div v-if="errors!==''">
            <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">code: {{ errorId}}</h6>
            <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn default-outline-btn bg-transparent" style="background-color: #FFF;" data-bs-dismiss="modal" @click="cancel()">
            {{ $t('business.no') }}
          </button>
          <button :disabled="!btnLoad" type="button" class="btn" style="background-color: #EB9355;" @click="deleteBusiness()">
            <span v-if="!btnLoad" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" style="color: #FFF;"></span>
            <span style="color: #FFF;">{{ $t('business.yes') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Create/Edit Business -->
  <div class="modal fade" id="companyModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <form @submit.prevent="save">
          <div class="modal-header">
            <h1 class="modal-title fs-5">{{ edit == 0 ? $t('business.addBusiness') : $t('business.editBusiness') }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="errors!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errorId}}</h6>
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>
            </div>
            <div v-if="success!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color:green">{{ success}}</h6>
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('business.businessName') }}</label>
                  <div>
                    <input type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" :placeholder="$t('business.businessNamePlaceholder')" v-model="formValues.name" :class="{ 'is-invalid': errorsBis['name'] }" id="name" @blur="validate('name')" />
                    <span class="invalid-feedback">{{ errorsBis['name']}}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('business.description') }}</label>
                  <div>
                    <input type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" :placeholder="$t('business.descriptionPlaceholder')" v-model="formValues.description" :class="{ 'is-invalid': errorsBis['description'] }" id="description" @blur="validate('description')" />
                    <span class="invalid-feedback">{{ errorsBis['description']}}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('business.maxAmount') }}</label>
                  <div>
                    <input type="number" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" :placeholder="$t('business.maxAmountPlaceholder')" v-model="formValues.maxAmount" :class="{ 'is-invalid': errorsBis['maxAmount'] }" id="maxAmount" @blur="validate('maxAmount')" @keyup="validate_phone_number($event.target.value,$event.target,12)" />
                    <span class="invalid-feedback">{{ errorsBis['maxAmount']}}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('business.requiresValidation') }}</label>
                  <select name="operator" id="operator" class="form-select fs-md-15 text-black shadow-none" @change="handleValidationChange" required>
                    <option value="N" :selected="selectedValidation === 'N'">{{ $t('business.no') }}</option>
                    <option value="O" :selected="selectedValidation === 'O'">{{ $t('business.yes') }}</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('business.category') }}</label>
                  <select name="business" id="business" class="form-select fs-md-15 text-black shadow-none" @change="handleCategoryChange">
                    <option value="">{{ $t('business.selectCategory') }}</option>
                    <option v-for="category in categories" :value="category.code" :key="category.code"> {{ category.name }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn text-white" style="background-color: #EB9355;" v-if="current_permissions('create_business', 'edit_business')">
              <span v-if="!btnLoad" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" style="color: #FFF;"></span>
              <i class="flaticon-plus position-relative ms-5 fs-12" style="color: #FFF;"></i>
              {{ edit == 0 ? $t('business.save') : $t('business.edit') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div id="snackbar"></div>
</template>

<script setup lang="ts">
import { ref, onMounted, reactive, inject, computed, watch } from "vue";
import axios from 'axios';
import router from '../../router/index'
import { useI18n } from "vue-i18n";
import * as yup from 'yup';
import { Business } from "@/utils/Model";

import { current_permissions } from '../../utils/permission';
import { validate_phone_number, showToast, checkSessionValidate } from "@/utils/function";

const backApi = inject('back');
const btnLoad = ref(true);
const { t } = useI18n();
const selectedValidation = ref('N');
const selectedCategory = ref('');

const loader = ref(false);

let token: string | null = localStorage.getItem('login_token');
let codeOrganization: string | null = localStorage.getItem('organization_code');
let role: string | null = localStorage.getItem('role');

// Toutes les lignes reçues du back
const allBusiness = ref(new Array<Business>());
const categories = ref(new Array<Business>());
let edit = 0;
let itemCode = '';

const searchQuery = ref('');
const page = ref(1);
const pageSize = ref(15);

const statusLabelOf = (status: boolean) =>
  status === false ? t('business.no') : t('business.yes');

const filteredBusiness = computed(() => {
  const q = searchQuery.value.trim().toLowerCase();
  if (!q) return allBusiness.value;
  return allBusiness.value.filter((b: any) => {
    const values = [
      b.code,
      b.organization?.name,
      b.name,
      b.description,
      b.maxPayoutAmount,
      b.payinBalance,
      b.payoutBalance,
      statusLabelOf(b.validatePayoutBeforProcess),
    ];
    return values.some(v => (v ?? '').toString().toLowerCase().includes(q));
  });
});

const filteredTotal = computed(() => filteredBusiness.value.length);
const numPages = computed(() => Math.max(1, Math.ceil(filteredTotal.value / pageSize.value)));

const showingFrom = computed(() => filteredTotal.value === 0 ? 0 : (page.value - 1) * pageSize.value + 1);
const showingTo = computed(() => Math.min(page.value * pageSize.value, filteredTotal.value));

const paginatedBusiness = computed(() => {
  const start = (page.value - 1) * pageSize.value;
  return filteredBusiness.value.slice(start, start + pageSize.value);
});

const goToPage = (targetPage: number) => {
  if (targetPage < 1 || targetPage > numPages.value || targetPage === page.value) return;
  page.value = targetPage;
}

watch(searchQuery, () => {
  page.value = 1;
});

let data: any[] = [];

const errors = ref('');
const errorId = ref('');
const success = ref('');
const errorsBis = { 'name': '', 'description': '', 'maxAmount': 0 };
const pageLoad = ref(false);

const formValues = reactive({
  name: "",
  description: "",
  maxAmount: 0
});

const schema = yup.object({
  name: yup.string().required('Le nom est requis'),
  description: yup.string().required('La description est requise'),
  maxAmount: yup.number().required('Le montant maximum est requis'),
});

function handleValidationChange(event) {
  selectedValidation.value = event.target.value;
}

function handleCategoryChange(event) {
  selectedCategory.value = event.target.value;
}

const initField = () => {
  formValues.name = '';
  formValues.description = '';
  formValues.maxAmount = 0;
  selectedValidation.value = 'N';
  edit = 0;
  errors.value = '';
  errorId.value = '';
  success.value = '';
}

const fetchBusinessPage = (targetPage: number) => {
  let baseUrl = '';
  if (role === 'SUPERADMIN') {
    baseUrl = `${backApi}/secure/business`;
  } else {
    baseUrl = `${backApi}/secure/business?organization=${codeOrganization}`;
  }
  const separator = baseUrl.includes('?') ? '&' : '?';
  const url = `${baseUrl}${separator}currentPage=${targetPage}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store'
    }
  });
}

const loadAllBusiness = async () => {
  try {
    const first = await fetchBusinessPage(1);
    const collected: any[] = [...first.data.data];
    const totalPages = first.data.pagination.numPages;

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchBusinessPage(p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    allBusiness.value = collected;
    data = collected;
    page.value = 1;
    console.log('Business chargés:', collected.length);
  } catch (error: any) {
    console.error('Erreur chargement business:', error);
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

const getBusinessParent = (arg = 1) => {
  let param = '';
  param = (role == 'SUPERADMIN') ? '' : `&organization=${codeOrganization}`;
  
  axios.get(backApi + '/secure/business?currentPage=' + arg + param, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
    categories.value = response.data.data;
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}

const showBusiness = (code) => {
  axios.get(backApi + '/secure/business/' + code + '/show', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
    formValues.name = response.data.name;
    formValues.description = response.data.description;
    formValues.maxAmount = response.data.maxPayoutAmount;
    selectedValidation.value = (response.data.validatePayoutBeforProcess) ? 'O' : 'N';
    itemCode = response.data.code;
    edit = 1;
    errors.value = '';
    errorId.value = '';
    success.value = '';
    console.log(response.data);
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      } else {
        console.log(error.response);
      }
    }
  });
}

const showScreen = (code) => {
  itemCode = code;
  errors.value = '';
  errorId.value = '';
}

const cancel = () => {
  itemCode = "";
  errorId.value = "";
  errors.value = "";
}

const save = () => {
  if (edit == 0) {
    storeBusiness()
  } else {
    updateBusiness()
  }
}

const storeBusiness = () => {
  btnLoad.value = false;
  try {
    schema.validateSync(formValues);

    axios.post(`${backApi}/secure/business/new`, {
      name: formValues.name,
      description: formValues.description,
      validatePayoutBeforProcess: (selectedValidation.value == 'N') ? false : true,
      maxPayoutAmount: formValues.maxAmount,
      organization: codeOrganization,
      parent: selectedCategory.value
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      btnLoad.value = true;
      if (response.status === 200) {
        showToast("Enregistrement effectué avec succès", "green");
        loadAllBusiness(); // Recharger les données
        // Fermer la modale
        const modal = document.getElementById('companyModal');
        if (modal) {
          const closeBtn = modal.querySelector('.btn-close') as HTMLElement;
          if (closeBtn) closeBtn.click();
        }
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
      btnLoad.value = true;
    });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
    btnLoad.value = true;
  }
}

const updateBusiness = () => {
  btnLoad.value = false;
  try {
    schema.validateSync(formValues);
    
    axios.put(`${backApi}/secure/business/${itemCode}/edit`, {
      name: formValues.name,
      description: formValues.description,
      validatePayoutBeforProcess: (selectedValidation.value == 'N') ? false : true,
      maxPayoutAmount: formValues.maxAmount,
      organization: codeOrganization,
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      btnLoad.value = true;
      if (response.status === 200) {
        showToast("Modification effectuée avec succès", "green");
        loadAllBusiness(); // Recharger les données
        // Fermer la modale
        const modal = document.getElementById('companyModal');
        if (modal) {
          const closeBtn = modal.querySelector('.btn-close') as HTMLElement;
          if (closeBtn) closeBtn.click();
        }
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
      btnLoad.value = true;
    });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
    btnLoad.value = true;
  }
}

const deleteBusiness = () => {
  btnLoad.value = false;
  try {
    const headers = {
      'Authorization': `Bearer ${token}`
    }
    const data = {
      code: itemCode
    }
    axios.delete(`${backApi}/secure/business/delete`, { headers, data })
      .then(response => {
        if (response.status === 200) {
          btnLoad.value = true;
          showToast("Suppression effectuée avec succès", "green");
          loadAllBusiness();
          // Fermer la modale
          const modal = document.getElementById('filterLeadModal');
          if (modal) {
            const closeBtn = modal.querySelector('.btn-close') as HTMLElement;
            if (closeBtn) closeBtn.click();
          }
        }
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 401) {
            router.push('/')
          } else {
            errorId.value = error.response.data.errorId;
            errors.value = error.response.data.message;
          }
        }
        btnLoad.value = true;
      });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
    btnLoad.value = true;
  }
}

function validate(field) {
  schema
    .validateAt(field, formValues)
    .then(() => {
      errorsBis[field] = "";
    })
    .catch(err => {
      errorsBis[field] = err.message;
    });
  errors.value = ''
}

onMounted(async () => {
  checkSessionValidate(1);
  await loadAllBusiness();
  getBusinessParent();

  setTimeout(function () {
    pageLoad.value = true;
  }, 1000)
});
</script>